import React from "react";
import { Card, ListGroup } from "react-bootstrap";

const ExpandedApplication = ({ data }: any) => {
  return (
    <Card style={{ width: "100%" }}>
      <Card.Body>
        <Card.Title>Dodatne informacije</Card.Title>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <strong>Telefon:</strong> {data.phone_number}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Telefon roditelja:</strong> {data.parent_phone_number}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Email:</strong> {data.email}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Email roditelja:</strong> {data.parent_email}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Napomena:</strong> {data.remark}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Kreirano:</strong>{" "}
            {new Date(data.created_at).toLocaleString("hr-HR")}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Ažurirano:</strong>{" "}
            {new Date(data.updated_at).toLocaleString("hr-HR")}
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default ExpandedApplication;
